<template>
  <div class="container-fluid mt-3">
    <div class="row centered">
      <div class="col-sm-4 col-md-4">
        <v-card
            tile
            flat
        >
          <div style="position:relative">
            <img class="step-images" src="@/assets/images/step_1.png"/>
            <div class="font-circle">1</div>
          </div>
          <v-card-text class="pb-0 px-0 mt-5">
            <p class="font-weight-bold text-center text-uppercase ">Fai la tua spesa con pochi click</p>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-sm-4 col-md-4">
        <v-card
            elevation-0
            tile
            flat
        >
          <div style="position:relative">
            <img class="step-images" src="@/assets/images/step_2.png"/>
            <div class="font-circle">2</div>
          </div>
          <v-card-text class="pb-0 px-0 mt-5">
            <p class="font-weight-bold text-center text-uppercase">I nostri produttori prepareranno
              Il tuo ordine con cura </p>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-sm-4 col-md-4">
        <v-card
            elevation-0
            tile
            flat
        >
          <div style="position:relative">
            <img class="step-images" src="@/assets/images/step_3.png"/>
            <div class="font-circle">3</div>
          </div>
          <v-card-text class="pb-0 px-0 mt-5 font-weight-bold">
            <p class="font-weight-bold  text-center text-uppercase">La tua spesa online ti viene consegnata
              direttamente a casa!</p>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: "Cardstransport",
  data: () => ({
    cards: [
      {title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 6},
      {title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6},
      {title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6},
    ],
  }),
}
</script>

<style scoped>
.step-images {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  display: block;

}

.font-circle {
  background: #732342;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  border-radius: 50%;
  color: #fafafa;
  text-align: center;
  font-size: 25px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>